import React, {useState, useEffect} from 'react';
import { useLocale } from 'components/special/LanguageProvider';

const SubjectSearch = ({ querySelectorInput, valueUpdate, placement, triggerIconClass, listData, nameObject, 
                        placeholder, selection, initialItem, isLoading, disabled, searchable}) => {

    const { t } = useLocale();

    // Working data
    const [selectedItem, setSelectedItem] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [currentFocusId, setCurrentFocusId] = useState("");
    const [queryInput, setQueryInput] = useState("");
    const [noResults, setNoResults] = useState("Engar niðurstöður");
    const isSearchable= searchable ? searchable : true;

    const getNameObject = (obj, prop, defval) => {
        if (typeof defval == 'undefined') defval = null;
        if (typeof nameObject[prop] == 'undefined') return defval;
        prop = nameObject[prop].split('.');
        for (let i = 0,l = prop.length; i < l; i++) {
            if(!obj) return defval;
            if(typeof obj[prop[i]] == 'undefined'){
                return defval;
            }
            obj = obj[prop[i]];
        }
        return obj;
    }

    const focusClick = () => {
        if(listData && listData.length > 0){
            triggerClick();
        }
    }

    const triggerClick = () => {
        if(listData && listData.length > 0){
            setIsOpen(!isOpen);
        }
    }

    const setItemFocus = (focus) => {
        if(focus){ // null = Focus selected item
            for(let i = 0, l = listData.length; i < l; i++){
                if(listData[i].id == currentFocusId){
                    if(focus == "down"){
                        if(i+1 < l){
                            setCurrentFocusId(listData[i+1].id);
                            break;
                        }else{
                            setCurrentFocusId(listData[0].id);
                            break;
                        }
                    }else if (focus == "up"){
                        if(i-1 >= 0){
                            setCurrentFocusId(listData[i-1].id);
                        }else{
                            setCurrentFocusId(listData[l-1].id);
                            break;
                        }
                    }
                }
            }
        }
    }

    const selectDropDownItem = (item, key) => {
        if(key && key.keyCode !== 13)   return; //If key is pressed when list is open an it's not Enter then return.
        setIsOpen(false);
        getSelectedItem(item);
    }
    
    const getSelectedItem = (item) => {
        let items = listData;
        let itemSelected = item || items[0];
        let selected = item;
        for(let i = 0, l = listData.length; i < l; i++){
            if(listData[i] === itemSelected){
                listData[i].selected = true;
                setQueryInput(getNameObject(items[i],0,""));
                selected = items[i];
            }else{
                listData[i].selected = false;
            }
        }
        setSelectedItem(selected);
        setCurrentFocusId(selected.id);
        selection({ item: selected });
    }

    const inputKeyDown = (e) => {
        switch (e.keyCode)
        {
            case 9://tab
            case 27://escape
            case 38://arrowUp
                if(isOpen){
                    triggerClick(); //close dropdown
                }
                break;
            case 40://downArrow
                if(!isOpen){
                    triggerClick(); //open dropdown
                    setItemFocus(null); //selected item focus
                }else{
                    setItemFocus("down");// next focus item
                }
                break;

            case 13://enter
                triggerClick();
                break;
            default:
                if(!isSearchable){ //if not searchable just allow the above list selection
                    e.preventDefault();
                }
        }

        if( e.keyCode == 13 && isSearchable ){
            querySelectorInput({input: queryInput});
            setIsOpen(true);
        }
    }

    const listItemKeyDown = (item, e) => {
        switch (e.keyCode)
        {
            case 9://tab
                if(isOpen){
                    triggerClick();
                }
                break;
            case 27://escape
                if(isOpen){
                    e.preventDefault();
                    triggerClick();
                }
                break;
            case 38://upArrow
                e.preventDefault();
                setItemFocus("up");
                break;
            case 40://downArrow
                e.preventDefault();
                setItemFocus("down");
                break;
            case 13://enter
                selectDropDownItem(item,e);
                break;
        }
    }

    useEffect(() => {
        if (currentFocusId != ""){
            let element = document.getElementById(currentFocusId);
            element.focus();
        }
    }, [currentFocusId])

    useEffect(() => {
        if (listData.length > 0) {
            let item = listData[initialItem];
            selection({ item: item });
            valueUpdate(item.source.subjectName);
            setSelectedItem(item);
            setQueryInput(item.source.subjectName);
            setCurrentFocusId(item.id);
        }
      }, [listData]);
    
    return (
        <div className={`form ci-dropdown ci-queryselector loading-input loading-${isLoading} drop-${placement} open-${isOpen} ${isOpen ? "open" : ""}`}>
            <div className="query-input input-icon">
                <input type="text" placeholder={placeholder} value={queryInput} onChange={e => setQueryInput(e.target.value)} onClick={() => focusClick()} 
                disabled={disabled} onKeyDown={(e) => inputKeyDown(e)} autoComplete="off"/>
                <div className="query-trigger">
                    <button className={`button transparent ${triggerIconClass} no-text`} tabIndex="-1" onClick={() => triggerClick()}><span className="caret"></span>
                    </button>
                </div>
                <span className="spinner-container x-small"><i className="spinner x-small icon-spinner2"></i></span>
            </div>
            <div className="ci-dropdown-container query-list-container">
                <ul className="no-style">
                    {listData.map((item,i) => 
                        <li key={i} className={`list-item ${selectedItem && selectedItem.id == item.id ? "selected" : ""}`}>
                            <a id={item.id} tabIndex="-1" className="dr-tab-index" onClick={() => selectDropDownItem(item)} onKeyDown={(e) => listItemKeyDown(item, e)}><span className="primary">{getNameObject(item,0,null)}</span>
                            {getNameObject(item,1,null) && <span className="secondary">- {getNameObject(item,1,"")}</span>} {getNameObject(item,2,null) && 
                            <span className="secondary"> ( {getNameObject(item,2,"")} )</span>}</a>
                        </li>
                    )}             
                    {listData.length === 0 && <span className="no-entry">{t(noResults)}</span>}
                </ul>
            </div>
        </div>
    );
};

export default SubjectSearch;
